import { convertToCurrentSystem } from 'utils/units';

export const UNSAVED_CELL_PLACEHOLDER = '-';

export const formatNumeric = (value) => value?.toLocaleString();

export const formatArea = (value, measurementSystem) => formatNumeric(convertToCurrentSystem(value, measurementSystem));
